import { createSelector } from 'reselect';

import { getAllReleases, getUIState } from '.';
import { filterDisplayableReleases } from '../utils/release-modal';

const getReleaseModalUIState = createSelector(getUIState, state => state.releaseModal);

export const isReleaseModalOpen = createSelector(getReleaseModalUIState, state => state.open);

export const isReleaseModalInPreviewMode = createSelector(getReleaseModalUIState, state => state.previewMode);

export const getDisplayableReleases = createSelector(getAllReleases, releases => filterDisplayableReleases(releases));

const getReleaseIdToDisplay = createSelector(
  getReleaseModalUIState,
  getDisplayableReleases,
  (state, releases) => state.releaseId || releases[0]?.id
);

export const getReleaseToDisplay = createSelector(
  getAllReleases,
  getReleaseIdToDisplay,
  (releases, releaseId) => releases.find(release => release.id === releaseId)
);
